import { render, staticRenderFns } from "./RulesInput.vue?vue&type=template&id=7d46b2e6&scoped=true"
import script from "./RulesInput.vue?vue&type=script&setup=true&lang=js"
export * from "./RulesInput.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RulesInput.vue?vue&type=style&index=0&id=7d46b2e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d46b2e6",
  null
  
)

export default component.exports